import { store } from '@/app/app-store';
import {
  BrcodeType,
  ContractReasonCancellation,
  PaymentDestination,
  PaymentMethod,
  RefundGroupStatus,
  RefundStatus,
  RefundType,
} from '@/app/shared/enums/';
import {
  AddressBillingModel,
  AttemptModel,
  CardChangerModel,
  ContactBillingModel,
  ContractModel,
  CustomerBillingModel,
  ComplementaryModel,
  InstallmentModel,
  PaymentInfoModel,
  PaymentMethodAvaiable,
  RefundGroupModel,
  RefundModel,
  RefundSettingsResponseModel,
  StatementProcessorResponseModel,
  TransactionModel,
  RefundSettingsModel,
  StatementModel,
  WebhookEventModel,
  WebhookEventResendModel,
} from '@/app/shared/models';
import { refsService as refs } from '@/app/shared/refs.service';
import ValueToApiParser from '@sone/sone-frontend-core/dist/utils/ValueToApiParser';
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';

@Module({ store, name: 'contractModule', namespaced: true, dynamic: true })
export class ContractModule extends VuexModule {
  public contract: ContractModel = new ContractModel();
  public customer: CustomerBillingModel = new CustomerBillingModel();
  public complementary: ComplementaryModel = new ComplementaryModel();
  public complementaries: ComplementaryModel[] = [];
  public address: AddressBillingModel = new AddressBillingModel();
  public email: ContactBillingModel = new ContactBillingModel();
  public phone: ContactBillingModel = new ContactBillingModel();
  public cellPhone: ContactBillingModel = new ContactBillingModel();
  public paymentInfo: PaymentInfoModel[] = [];
  public installment: InstallmentModel = new InstallmentModel();
  public installmentOriginalDueDate = '';
  public refund: RefundModel = new RefundModel();
  public refundSettings: RefundSettingsModel = new RefundSettingsModel();
  public statements: StatementModel[] = [];
  public refundGroup: RefundGroupModel = new RefundGroupModel();
  public webhookEvent: WebhookEventModel = new WebhookEventModel();
  public installmentList: InstallmentModel[] = [];
  public chargebackHistoryList: InstallmentModel[] = [];
  public installmentSelectedList: InstallmentModel[] = [];
  public webhookEventList: WebhookEventModel[] = [];
  public refundList: RefundModel[] = [];
  public paymentMethodAvaiable: PaymentMethodAvaiable[] = [];
  public refundApproveList: RefundModel[] = [];
  public refundDenyList: RefundModel[] = [];
  public refundGroupRequestedList: RefundGroupModel[] = [];
  public refundGroupList: RefundGroupModel[] = [];
  public refundGroupApprovedList: RefundGroupModel[] = [];
  public refundsByContract: RefundModel[] = [];
  public installmentPaymentInfo: PaymentInfoModel = new PaymentInfoModel();
  public attemptList: AttemptModel[] = [];
  public transactionList: TransactionModel[] = [];
  public allListRefund: { idRefunGroup: string; refund: RefundModel }[] = [];
  public showBankDataForm = false;
  public enableButtonRefund = false;
  public newAttempt = false;
  public chargeRefundConfirmed = false;
  public startDate = '';
  public finishDate = '';
  public paymentDestination: PaymentDestination = PaymentDestination.Undefined;
  public reason = '';
  public refundGroupStatus: RefundGroupStatus = RefundGroupStatus.Undefined;
  public refundGroupId = '';
  public blockedInCampaing = false;

  @Mutation
  public SET_CONTRACT(contract: ContractModel) {
    this.contract = {
      ...contract,
      FinishDate: contract.FinishDate
        ? refs.moment(new Date(contract.FinishDate)).format('YYYY-MM-DD')
        : '',
    };
  }
  @Mutation
  public SET_PAYMENT_DESTINATION(paymentDestination: PaymentDestination) {
    this.paymentDestination = paymentDestination;
  }
  @Mutation
  public SET_REFUNDGROUP_STATUS(refundGroupStatus: RefundGroupStatus) {
    this.refundGroupStatus = refundGroupStatus;
  }
  @Mutation
  public SET_REASON(reason: string) {
    this.reason = reason;
  }
  @Mutation
  public SET_STARTDATE(startDate: string) {
    this.startDate = startDate;
  }
  @Mutation
  public SET_FINISHDATE(finishDate: string) {
    this.finishDate = finishDate;
  }
  @Mutation
  public SET_NEWATTEMPT(value: boolean) {
    this.newAttempt = value;
  }
  @Mutation
  public SET_CHANGE_CONFIRM_REFUND(value: boolean) {
    this.chargeRefundConfirmed = value;
  }
  @Mutation
  public SET_ALL_LIST_REFUND(
    data: { idRefunGroup: string; refund: RefundModel }[]
  ) {
    this.allListRefund = data;
  }
  @Mutation
  public SET_ADD_LIST_REFUND(data: {
    idRefunGroup: string;
    refund: RefundModel;
  }) {
    this.allListRefund.push(data);
  }
  @Mutation
  public SET_CUSTOMER(customer: CustomerBillingModel[]) {
    const customerFind = refs._.head(customer);
    this.customer = customerFind
      ? {
          ...customerFind,
          Birthdate: customerFind.Birthdate
            ? refs
                .moment(customerFind.Birthdate, 'DD/MM/YYYY')
                .format('YYYY-MM-DD')
            : '',
        }
      : new CustomerBillingModel();
  }
  @Mutation
  public SET_COMPLEMENTARIES(complementaries: ComplementaryModel[]) {
    this.complementaries = complementaries;
  }
  @Mutation
  public SET_COMPLEMENTARY(complementary: ComplementaryModel) {
    this.complementary = complementary;
  }
  @Mutation
  public SET_ADDRESS(address: AddressBillingModel) {
    this.address = address;
  }
  @Mutation
  public SET_EMAIL(email: ContactBillingModel) {
    this.email = email;
  }
  @Mutation
  public SET_PHONE(phone: ContactBillingModel) {
    this.phone = phone;
  }
  @Mutation
  public SET_CELLPHONE(cellPhone: ContactBillingModel) {
    this.cellPhone = cellPhone;
  }
  @Mutation
  public SET_PAYMENT_INFO(paymentInfo: PaymentInfoModel[]) {
    // if (firstPaymentInfo?.CardExpiration)
    //   firstPaymentInfo.CardExpiration = refs
    //     .moment(firstPaymentInfo.CardExpiration, 'YYYYMM')
    //     .format('MM/YYYY');
    this.paymentInfo = paymentInfo;
  }
  @Mutation
  public SET_INSTALLMENT(installment: InstallmentModel) {
    this.installment = installment;
  }
  @Mutation
  public SET_INSTALLMENT_ORIGINALDUEDATE(installment: InstallmentModel) {
    this.installmentOriginalDueDate = refs
      .moment(installment.OriginalDueDate)
      .format('YYYY-MM-DD');
  }
  @Mutation
  public SET_INSTALLMENT_LIST(installmentList: InstallmentModel[]) {
    this.installmentList = installmentList;
  }
  @Mutation
  public SET_CHARGEBACK_HISTORY(installmentList: InstallmentModel[]) {
    this.chargebackHistoryList = installmentList;
  }
  @Mutation
  public SET_INSTALLMENT_SELECTED_LIST(installmentList: InstallmentModel[]) {
    this.installmentSelectedList = installmentList;
  }
  @Mutation
  public SET_WEBHOOK_EVENT(webhookEvent: WebhookEventModel) {
    this.webhookEvent = webhookEvent;
  }
  @Mutation
  public SET_WEBHOOK_EVENT_LIST(webhookEventList: WebhookEventModel[]) {
    this.webhookEventList = webhookEventList;
  }
  @Mutation
  public SET_REFUND(refund: RefundModel) {
    this.refund = refund;
  }
  @Mutation
  public SET_REFUND_SETTINGS(refundSettings: RefundSettingsModel) {
    this.refundSettings = refundSettings;
  }
  @Mutation
  public SET_STATEMENTS(statements: StatementModel[]) {
    this.statements = statements;
  }
  @Mutation
  public SET_REFUND_LIST(refundList: RefundModel[]) {
    this.refundList = refundList;
  }
  @Mutation
  public SET_PAYMENT_METHOD_AVAIABLE(
    paymentMethodAvaiable: PaymentMethodAvaiable[]
  ) {
    this.paymentMethodAvaiable = paymentMethodAvaiable;
  }
  @Mutation
  public SET_REFUND_APPROVE_LIST(refundApproveList: RefundModel[]) {
    this.refundApproveList = refundApproveList;
  }
  @Mutation
  public SET_REFUND_DENY_LIST(refundDenyList: RefundModel[]) {
    this.refundDenyList = refundDenyList;
  }
  @Mutation
  public SET_REFUND_GROUP(refundGroup: RefundGroupModel) {
    this.refundGroup = refundGroup;
  }
  @Mutation
  public SET_REFUND_GROUP_REQUESTED_LIST(refundGroupList: RefundGroupModel[]) {
    this.refundGroupRequestedList = refundGroupList;
  }
  @Mutation
  public SET_REFUND_GROUP_APPROVED_LIST(refundGroupList: RefundGroupModel[]) {
    this.refundGroupApprovedList = refundGroupList;
  }
  @Mutation
  public SET_REFUNDS_BY_CONTRACT(refundsByContract: RefundModel[]) {
    this.refundsByContract = refundsByContract;
  }
  @Mutation
  public SET_INSTALLMENT_PAYMENT_INFO(paymentInfo: PaymentInfoModel) {
    this.installmentPaymentInfo = paymentInfo;
  }
  @Mutation
  public SET_REFUND_GROUP_LIST(refundGroupList: RefundGroupModel[]) {
    this.refundGroupList = refundGroupList;
  }
  @Mutation
  public SET_ATTEMPT_LIST(attemptList: AttemptModel[]) {
    this.attemptList = refs._.chain(attemptList)
      .orderBy((attempt) =>
        refs.moment(attempt.ExecutionDate, 'DD/MM/YY HH:mm:ss')
      )
      .map((attempt, index) => {
        return { ...attempt, Number: index + 1 };
      })
      .value();
  }
  @Mutation
  public SET_TRANSACTION_LIST(transactionList: TransactionModel[]) {
    this.transactionList = transactionList;
  }
  @Mutation
  public SET_REFUND_GROUP_ID(refundGroupId: string) {
    this.refundGroupId = refundGroupId;
  }
  @Mutation
  public SET_CAMPAIGN_BLOCK(blockedInCampaing: boolean) {
    this.blockedInCampaing = blockedInCampaing;
  }

  @Action({ commit: 'SET_CONTRACT', rawError: true })
  public async loadContractById(contractId: string) {
    return await refs.services.contract.getContractById(contractId);
  }
  @Action({ rawError: true })
  public async updateContract(data: {
    contractId: string;
    contract: ContractModel;
    update: boolean;
  }) {
    const contract = data.update
      ? {
          Id: data.contract.Id,
          OurCode: data.contract.OurCode,
          Value: data.contract.Value,
          //   StartDate: data.contract.StartDate,
          //   FinishDate: data.contract.FinishDate
          //     ? data.contract.Infinite
          //      ? ''
          //       : refs.moment(new Date(data.contract.FinishDate)).toISOString()
          //     : data.contract.FinishDate,
          //  NumberOfInstallments: data.contract.NumberOfInstallments,
          //  Frequency: data.contract.Frequency,
          DueDate: data.contract.DueDate,
          //   Infinite: data.contract.Infinite,
        }
      : {
          Id: data.contract.Id,
          OurCode: data.contract.OurCode,
          Value: data.contract.Value,
          // StartDate: data.contract.StartDate,
          // FinishDate: data.contract.FinishDate
          //   ? data.contract.Infinite
          //     ? ''
          //     : refs.moment(new Date(data.contract.FinishDate)).toISOString()
          //   : data.contract.FinishDate,
          // NumberOfInstallments: data.contract.NumberOfInstallments,
          // Frequency: data.contract.Frequency,
          // Infinite: data.contract.Infinite,
        };
    await refs.services.contract.updateContract(data.contractId, contract, '');
  }
  @Action({ rawError: true })
  public async cancelContract(data: {
    contractId: string;
    ReasonForCancellation: ContractReasonCancellation;
    descReason: string;
  }) {
    await refs.services.contract.cancelContract(data);
  }
  @Action({ rawError: true })
  public async reactivateContract(data: {
    contractId: string;
    descReason: string;
    generateCharge: boolean;
    installments: InstallmentModel[];
  }) {
    await refs.services.contract.reactivateContract(
      data.contractId,
      data.descReason,
      data.generateCharge,
      data.installments
    );
  }

  @Action({ commit: 'SET_CUSTOMER', rawError: true })
  public async loadCustomerByContractId(contractId: string) {
    return await refs.services.contract.getCustomerByContractId(contractId);
  }
  @Action({ rawError: true })
  public async updateCustomer(data: {
    contractId: string;
    customerId: string;
    customer: CustomerBillingModel;
    newAddress: boolean;
    newEmail: boolean;
    newPhone: boolean;
    newCellPhone: boolean;
    descReason: string;
  }) {
    data.customer.Addresses = [];
    data.customer.Contacts = [];

    if (data.customer.DocumentType == 'CNPJ') {
      data.customer.Birthdate = '';
    }

    this.address.PostalCode && data.customer.Addresses.push(this.address);
    this.email.Value && data.customer.Contacts.push(this.email);
    this.phone.Value && data.customer.Contacts.push(this.phone);
    this.cellPhone.Value && data.customer.Contacts.push(this.cellPhone);

    return await refs.services.contract.updateCustomer(
      data.contractId,
      data.customerId,
      data.customer,
      data.descReason
    );
  }

  @Action({ commit: 'SET_COMPLEMENTARIES', rawError: true })
  public async loadComplementaryByContractId(contractId: string) {
    return await refs.services.contract.getComplementaryByContractId(
      contractId
    );
  }

  @Action({ rawError: true })
  public async addComplementary(data: {
    contractId: string;
    complementary: ComplementaryModel;
    descReason: string;
  }) {
    return await refs.services.contract.addComplementary(
      data.contractId,
      data.complementary,
      data.descReason
    );
  }

  @Action({ rawError: true })
  public async updateComplementary(data: {
    contractId: string;
    complementaryId: string;
    complementary: ComplementaryModel;
    descReason: string;
  }) {
    return await refs.services.contract.updateComplementary(
      data.contractId,
      data.complementaryId,
      data.complementary,
      data.descReason
    );
  }

  @Action({ rawError: true })
  public async removeComplementary(data: {
    contractId: string;
    complementaryId: string;
    descReason: string;
  }) {
    return await refs.services.contract.removeComplementary(
      data.contractId,
      data.complementaryId,
      data.descReason
    );
  }

  @Action({ commit: 'SET_PAYMENT_INFO', rawError: true })
  public async loadPaymentInfoByContractId(contractId: string) {
    return await refs.services.contract.getPaymentInfoByContractId(contractId);
  }
  @Action({ commit: 'SET_PAYMENT_INFO', rawError: true })
  public async loadPaymentInfoByInstallmentId(data: {
    contractId: string;
    installmentId: string;
  }) {
    return await refs.services.contract.getPaymentInfoByInstallmentId(
      data.contractId,
      data.installmentId
    );
  }
  @Action({ rawError: true })
  public async addCardChanger(card: CardChangerModel) {
    const result = await refs.services.contract.addCard(card);
    return result;
  }

  @Action({ rawError: true })
  public async updatePaymentInfo(data: {
    paymentInfo: PaymentInfoModel[];
    contractId: string;
    descReason: string;
  }) {
    data.paymentInfo.forEach(async (payment) => {
      if (
        refs.enums.PaymentMethod[payment.PaymentMethod] ==
          refs.enums.PaymentMethod.Credit.toString() &&
        payment.Credit
      ) {
        if (payment.Credit.CardTruncatedNumber) {
          switch (payment.Credit.CardTruncatedNumber.length) {
            case 13:
              payment.Credit.CardTruncatedNumber =
                payment.Credit.CardTruncatedNumber.substr(0, 6) +
                '***' +
                payment.Credit.CardTruncatedNumber.substr(9, 12);
              break;
            case 14:
              payment.Credit.CardTruncatedNumber =
                payment.Credit.CardTruncatedNumber.substr(0, 6) +
                '****' +
                payment.Credit.CardTruncatedNumber.substr(10, 13);
              break;
            case 15:
              payment.Credit.CardTruncatedNumber =
                payment.Credit.CardTruncatedNumber.substr(0, 6) +
                '*****' +
                payment.Credit.CardTruncatedNumber.substr(11, 14);
              break;
            case 16:
              payment.Credit.CardTruncatedNumber =
                payment.Credit.CardTruncatedNumber.substr(0, 6) +
                '******' +
                payment.Credit.CardTruncatedNumber.substr(12, 15);
              break;
          }
        }
      }
    });
    if (
      refs.enums.PaymentDestination[
        refs.modules.contract.paymentDestination
      ].toString() ==
      refs.enums.PaymentDestination[refs.enums.PaymentDestination.Contract]
    ) {
      await refs.services.contract.updatePaymentInfoContract(
        data.contractId,
        data.paymentInfo,
        data.descReason
      );
    } else {
      await refs.services.contract.updatePaymentInfoParcel(
        data.contractId,
        data.paymentInfo,
        this.installment.Id,
        data.descReason
      );
    }
  }

  @Action({ rawError: true })
  public async updatePaymentMethod(data: {
    paymentInfo: PaymentInfoModel[];
    contractId: string;
    installmentId: string;
    descReason: string;
  }) {
    await refs.services.contract.updatePaymentMethod(
      data.contractId,
      data.installmentId,
      data.paymentInfo,
      data.descReason
    );
  }

  // @Action({ commit: 'SET_INSTALLMENT_PAYMENT_INFO', rawError: true })
  // public async loadPaymentInfoById(data: {
  //   contractId: string;
  //   paymentInfoId: string;
  // }) {
  //   return await refs.services.contract.getPaymentInfoBytId(
  //     data.contractId,
  //     data.paymentInfoId
  //   );
  // }

  @Action({ commit: 'SET_INSTALLMENT_LIST', rawError: true })
  public async loadInstallmentList(contractId: string) {
    new ValueToApiParser('date', 'OriginalDueDate', {
      start: new Date(),
    }).parse();
    return await refs.services.contract.getInstallmentList(contractId);
  }

  @Action({ commit: 'SET_CHARGEBACK_HISTORY', rawError: true })
  public async loadChargebackHistory(data: {
    contractId: string;
    installmentId: string;
  }) {
    new ValueToApiParser('date', 'OriginalDueDate', {
      start: new Date(),
    }).parse();
    return await refs.services.contract.getInstallmentChargebackHistory(
      data.contractId,
      data.installmentId
    );
  }

  @Action({ commit: 'SET_REFUND_LIST', rawError: true })
  public async loadRefundList() {
    return await refs.services.contract.getRefundList();
  }

  @Action({ commit: 'SET_REFUND_SETTINGS', rawError: true })
  public async loadRefundSettings(paymentMethod: PaymentMethod) {
    const filter = `BillingMode=${this.contract.BillingMode};PaymentMethod=${paymentMethod}`;
    return (await refs.services.refund.loadRefundSettings(filter))[0];
  }

  @Action({ commit: 'SET_STATEMENTS', rawError: true })
  public async loadStatementsByContract() {
    const filter = `ContractId=${refs.modules.contract.contract.Id}`;
    return await refs.services.refund.loadStatements(filter);
  }

  @Action({ rawError: true })
  public async loadCovenant(id: string) {
    return await refs.services.refund.loadCovenant(id);
  }

  @Action({ rawError: true })
  public async loadRefundExternal(covenantId: string) {
    const filter = `CovenantId=${covenantId};Active=true`;
    return await refs.services.refund.loadRefundExternalList(filter);
  }

  @Action({ commit: 'SET_PAYMENT_METHOD_AVAIABLE', rawError: true })
  public async loadPaymentMethodAvaiableSettings(data: {
    billingMode: string;
    frequency: string;
  }) {
    const filter =
      'Filter=BillingMode=' +
      refs.enums.BillingMode[Number(data.billingMode)] +
      ';Frequency=' +
      refs.enums.PaymentFrequency[Number(data.frequency)];

    return await refs.services.contract.getPaymentMethodAvaiable(filter);
  }

  @Action({ commit: 'SET_REFUND_GROUP', rawError: true })
  public async loadRefundGroup(refundGroupId: string) {
    const refundGroup = await refs.services.contract.getRefundGroup(
      refundGroupId
    );
    if (refundGroup.Refunds) {
      refundGroup.Refunds = refundGroup.Refunds.sort((a, b) =>
        a.Statements &&
        b.Statements &&
        a.Statements[0].InstallmentNumber > b.Statements[0].InstallmentNumber
          ? 1
          : -1
      );
    }
    return refundGroup;
  }
  @Action({ commit: 'SET_REFUNDS_BY_CONTRACT', rawError: true })
  public async refundsByContractId(contractNumber: number) {
    return await refs.services.contract.getRefundListByContract(contractNumber);
  }
  @Action({ commit: 'SET_REFUND_GROUP_LIST', rawError: true })
  public async loadRefundGroupList(data: {
    startDate: string;
    finishDate: string;
    status: string;
  }) {
    data.startDate = data.startDate + 'T00:00:00Z';
    data.finishDate = data.finishDate + 'T23:59:59Z';
    const refundTypeFilter =
      data.status == 'Failed'
        ? ';Type=' + refs.enums.RefundType[RefundType.Transfer]
        : '';
    const filter =
      'Filter=Created>=' +
      data.startDate +
      ';Created<=' +
      data.finishDate +
      ';Status=' +
      data.status +
      refundTypeFilter;
    const refundGroupList = await refs.services.contract.getRefundGroupList(
      filter
    );
    if (refundGroupList && refundGroupList.length > 0) {
      await refs.services.contract.getContractsCustomerName(refundGroupList);
    }
    return refundGroupList;
  }
  @Action({ rawError: true })
  public async createInstallment(data: {
    contractId: string;
    installment: InstallmentModel;
  }) {
    await refs.services.contract.createInstallment(data.contractId, {
      ...data.installment,
      OriginalDueDate: data.installment.OriginalDueDate
        ? refs.moment(data.installment.OriginalDueDate, 'YYYY/MM/DD').toDate()
        : data.installment.OriginalDueDate,
    });
  }
  @Action({ rawError: true })
  public async createAttempt(data: {
    contractId: string;
    installment: InstallmentModel;
  }) {
    const OriginalDueDate = data.installment.OriginalDueDate
      ? refs.moment(data.installment.OriginalDueDate, 'YYYY/MM/DD').toDate()
      : data.installment.OriginalDueDate;
    await refs.services.contract.createAttempt(
      data.contractId,
      data.installment.Id,
      OriginalDueDate
    );
  }
  @Action({ rawError: true })
  public async updateInstallment(data: {
    contractId: string;
    installmentId: string;
    installment: InstallmentModel;
    descReason: string;
  }) {
    await refs.services.contract.updateInstallment(
      data.contractId,
      data.installmentId,
      data.installment,
      data.descReason
    );
  }
  @Action({ rawError: true })
  public async updateRefundGroupFailed(data: {
    idRefundGroup: string;
    status: RefundStatus;
    failed: boolean;
    paymentInfo: PaymentInfoModel;
    type: number;
    brcodeType: BrcodeType;
    newAttempt: boolean;
  }) {
    await refs.services.contract.updateRefundGroup(
      data.idRefundGroup,
      data.status,
      data.failed,
      data.paymentInfo,
      data.type,
      data.brcodeType,
      data.newAttempt
    );
  }
  @Action({ rawError: true })
  public async refundInstallment(data: {
    installments: InstallmentModel[];
    paymentInfo: PaymentInfoModel;
    financialInstitutionCode: { value: string; label: string };
    refundPaymentMethod: number;
    pixType: BrcodeType;
    markOff: boolean;
    reason: string;
    allRefundsExternal: boolean;
  }) {
    const refundGroup: RefundGroupModel = new RefundGroupModel();
    refundGroup.PaymentsInfo = [];
    refundGroup.MarkOff = data.markOff;
    if (data.installments[0] && data.installments[0].PaymentInfos) {
      refundGroup.Name = data.installments[0].PaymentInfos[0].Name;
    }
    data.paymentInfo.FinancialInstitutionCode =
      data.financialInstitutionCode.value;
    const paymentsInfo = await this.listPaymentsRefunds({
      installments: data.installments,
      refundPaymentMethod: data.refundPaymentMethod,
      paymentInfo: data.paymentInfo,
      pixType: data.pixType,
    });
    refundGroup.PaymentsInfo = paymentsInfo;
    refundGroup.ContractNumber = refs.modules.contract.contract.Number?.toString();
    refundGroup.Reason = data.reason;
    refundGroup.AllRefundsExternal = data.allRefundsExternal;
    await refs.services.contract.refundInstallment(refundGroup);
  }
  @Action({ rawError: true })
  private async listPaymentsRefunds(data: {
    installments: InstallmentModel[];
    refundPaymentMethod: number;
    paymentInfo: PaymentInfoModel;
    pixType: BrcodeType;
  }) {
    const paymentsInfo: PaymentInfoModel[] = [];
    await Promise.all(
      data.installments.map(async (installment) => {
        await this.verifyBankDataTrue({
          installment: installment,
          paymentMethod:
            installment.PaymentInfos != undefined
              ? installment.PaymentInfos[0].PaymentMethod
              : 0,
        }).then((result) => {
          if (result.value) {
            const paymentInfoTransfer = Object.assign({}, data.paymentInfo);
            paymentInfoTransfer.InstallmentId = installment.Id;
            paymentInfoTransfer.Value = installment.PartialValue
              ? installment.PartialValue
              : (installment.Value || 0) - (installment.TotalValueRefunds || 0);
            if (paymentInfoTransfer.Value == 0) {
              return;
            }

            if (installment && installment.PaymentInfos) {
              paymentInfoTransfer.Name = installment
                ? installment.PaymentInfos[0].Name
                : '';
              paymentInfoTransfer.Document = installment
                ? installment.PaymentInfos[0].Document
                : '';
              paymentInfoTransfer.DocumentType = installment
                ? installment.PaymentInfos[0].DocumentType
                : '';
            }
            if (data.refundPaymentMethod == refs.enums.RefundType.Brcode) {
              paymentInfoTransfer.Type =
                refs.enums.RefundType[RefundType.Brcode];
              paymentInfoTransfer.BrcodeType = data.pixType;
            } else if (
              data.refundPaymentMethod == refs.enums.RefundType.Transfer
            ) {
              paymentInfoTransfer.Type =
                refs.enums.RefundType[RefundType.Transfer];
            } else {
              paymentInfoTransfer.Type =
                refs.enums.RefundType[RefundType.Origin];
            }
            paymentsInfo.push(paymentInfoTransfer);
          } else {
            const daysAgo = refs
              .moment(new Date())
              .subtract(330, 'days')
              .toDate();
            let paymentInfoOrigin = new PaymentInfoModel();
            if (result.date < daysAgo) {
              paymentInfoOrigin = Object.assign({}, data.paymentInfo);
            }
            paymentInfoOrigin.InstallmentId = installment.Id;
            paymentInfoOrigin.Value = installment.PartialValue
              ? installment.PartialValue
              : (installment.Value || 0) - (installment.TotalValueRefunds || 0);
            if (paymentInfoOrigin.Value == 0) {
              return;
            }
            paymentInfoOrigin.Type = refs.enums.RefundType[RefundType.Origin];
            if (installment && installment.PaymentInfos) {
              paymentInfoOrigin.Name = installment
                ? installment.PaymentInfos[0].Name
                : '';
              paymentInfoOrigin.Document = installment
                ? installment.PaymentInfos[0].Document
                : '';
              paymentInfoOrigin.DocumentType = installment
                ? installment.PaymentInfos[0].DocumentType
                : '';
            }
            paymentsInfo.push(paymentInfoOrigin);
          }
        });
      })
    );
    return paymentsInfo;
  }
  @Action({ rawError: true })
  private async verifyBankDataTrue(data: {
    installment: InstallmentModel;
    paymentMethod: PaymentMethod;
  }) {
    let finishDate = new Date();
    const attemptList = await refs.services.contract.getAttemptList(
      refs.modules.contract.contract.Id,
      data.installment.Id
    );
    attemptList.forEach((attempt) => {
      if (
        attempt.LastTransaction &&
        attempt.LastTransaction.Status &&
        refs.enums.TransactionStatus[attempt.LastTransaction.Status] ==
          refs.enums.TransactionStatus.Approved.toString()
      ) {
        finishDate = refs.moment(attempt.LastTransaction.Date).toDate();
      }
    });
    const oneYearAgo = refs
      .moment(new Date())
      .subtract(1, 'year')
      .toDate();

    if (
      finishDate < oneYearAgo ||
      refs.enums.PaymentMethod[data.paymentMethod] !=
        refs.enums.PaymentMethod.Credit.toString()
    ) {
      return { value: true, date: finishDate };
    } else return { value: false, date: finishDate };
  }
  @Action({ rawError: true })
  public async allowanceInstallment(data: {
    contractId: string;
    installmentId: string;
    descReason: string;
  }) {
    await refs.services.contract.allowanceInstallment(
      data.contractId,
      data.installmentId,
      data.descReason
    );
  }
  @Action({ rawError: true })
  public async paidByOtherWayInstallment(data: {
    contractId: string;
    installmentId: string;
    descReason: string;
  }) {
    await refs.services.contract.paidByOtherWayInstallment(
      data.contractId,
      data.installmentId,
      data.descReason
    );
  }
  @Action({ rawError: true })
  public async defaulterInstallment(data: {
    contractId: string;
    installmentId: string;
    descReason: string;
  }) {
    await refs.services.contract.defaulterInstallment(
      data.contractId,
      data.installmentId,
      data.descReason
    );
  }
  @Action({ rawError: true })
  public async cancelInstallment(data: {
    contractId: string;
    installmentId: string;
    descReason: string;
  }) {
    await refs.services.contract.cancelInstallment(
      data.contractId,
      data.installmentId,
      data.descReason
    );
  }

  @Action({ commit: 'SET_ATTEMPT_LIST', rawError: true })
  public async loadAttemptList(data: {
    contractId: string;
    installmentId: string;
  }) {
    return await refs.services.contract.getAttemptList(
      data.contractId,
      data.installmentId
    );
  }
  @Action({ commit: 'SET_TRANSACTION_LIST', rawError: true })
  public async loadTransactionList(data: {
    contractId: string;
    installmentId: string;
    attemptId: string;
  }) {
    return await refs.services.contract.getTransactionList(
      data.contractId,
      data.installmentId,
      data.attemptId
    );
  }

  @Action({ rawError: true })
  public async resendBankSlip(data: {
    contractId: string;
    installmentId: string;
    listEmails: string;
  }) {
    return await refs.services.contract.resendBankSlip(
      data.contractId,
      data.installmentId,
      data.listEmails
    );
  }

  @Action({ rawError: true })
  public async resendBRCode(data: {
    contractId: string;
    installmentId: string;
    listEmails: string;
  }) {
    return await refs.services.contract.resendBRCode(
      data.contractId,
      data.installmentId,
      data.listEmails
    );
  }

  @Action({ rawError: true })
  public async generateLinkUpdate(data: {
    contractId: string;
    installmentList: string[];
    updateContract: boolean;
    emails: string;
  }) {
    await refs.services.contract.generateLinkUpdate(
      data.contractId,
      data.installmentList,
      data.updateContract,
      data.emails
    );
  }

  public async abortRefundGroup(data: {
    refundGroupId: string;
    reason: string;
  }) {
    await refs.services.contract.abortRefundGroup(
      data.refundGroupId,
      data.reason
    );
  }

  @Action({ rawError: true })
  public async verifyPartialRefundByInstallmentId(
    installmentIds: string[]
  ): Promise<StatementProcessorResponseModel[] | undefined> {
    const res = await refs.services.contract.getPartialRefundByInstallmentId(
      installmentIds
    );
    if (!res?.length) {
      return;
    }

    return res;
  }

  @Action({ rawError: true })
  public async verifyDaysToRefundOnOrigin(
    paymentMethod: PaymentMethod
  ): Promise<RefundSettingsResponseModel> {
    const res = await refs.services.contract.getRefundConfigs();

    const config = res?.RefundSettings?.filter(
      (settings) =>
        settings.BillingMode === this.contract.BillingMode &&
        settings.PaymentMethod === paymentMethod
    )[0];

    return config as RefundSettingsResponseModel;
  }

  @Action({ rawError: true })
  public async getRefundFile(refundId: string) {
    const result = await refs.services.contract.getRefundFile(refundId);
    return result;
  }

  @Action({ rawError: true })
  public async addContact(data: {
    contractId: string;
    customerId: string;
    contact: ContactBillingModel[];
  }) {
    const result = await refs.services.contract.addContact(
      data.contractId,
      data.customerId,
      data.contact
    );
    return result;
  }

  @Action({ rawError: true })
  public async forceUpdateStatus(data: {
    contractId: string;
    installmentId: string;
    params: {};
  }) {
    const result = await refs.services.contract.forceUpdateStatus(
      data.contractId,
      data.installmentId,
      data.params
    );
    return result;
  }

  @Action({ rawError: true })
  public async sendIntermediateEmail(data: {
    contractId: string;
    installmentId: string;
  }) {
    const result = await refs.services.contract.sendIntermediateEmail(
      data.contractId,
      data.installmentId
    );
    return result;
  }

  @Action({ commit: 'SET_CAMPAIGN_BLOCK', rawError: true })
  public async getCampaignBlock(contractId: string) {
    return await refs.services.contract.getCampaignBlock(contractId);
  }

  @Action({ commit: 'SET_CAMPAIGN_BLOCK', rawError: true })
  public async createCampaignBlock(contractId: string) {
    return await refs.services.contract.createCampaignBlock(contractId);
  }

  @Action({ commit: 'SET_CAMPAIGN_BLOCK', rawError: true })
  public async deleteCampaignBlock(contractId: string) {
    const result = await refs.services.contract.deleteCampaignBlock(contractId);
    return !result;
  }

  @Action({ rawError: true })
  public async resendWebhook(data: {
    contractId: string;
    list: WebhookEventResendModel[];
  }) {
    await refs.services.contract.resendWebhook(data.contractId, '', data.list);
  }

  @Action({ commit: 'SET_WEBHOOK_EVENT_LIST', rawError: true })
  public async loadWebhookEvents(contractId: string) {
    return await refs.services.contract.getWebhookEventsByContractId(
      contractId
    );
  }
}
